import { render } from "./TaskCreation.vue?vue&type=template&id=3ca5ca0a"
import script from "./TaskCreation.vue?vue&type=script&lang=js"
export * from "./TaskCreation.vue?vue&type=script&lang=js"

import "./TaskCreation.vue?vue&type=style&index=0&id=3ca5ca0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__